
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import AuthService from '@/services/auth';
import IconOrLoader from '@/components/svg/IconOrLoader.vue';

@Component({
    components: {
        IconOrLoader,
    },
})
export default class Login extends Vue {
    authService = new AuthService();

    loading = false;

    email: string = null;

    password: string = null;

    authFailed = false;

    login() {
        this.loading = true;

        this.authService
            .login(this.email, this.password)
            .then(() => this.authService.currentUser)
            .catch(({ response }) => {
                if (response.status === 400) {
                    this.password = '';
                    this.$nextTick(() => {
                        this.authFailed = true;
                    });
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    @Watch('email')
    @Watch('password')
    resetAuthFailure() {
        this.authFailed = false;
    }
}
